// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1_7DH","footer":"ModalFilter_footer__2q9A8"};